// @ts-nocheck

import { Component } from '@theme/component';

class FloatingCloudsComponent extends Component {
  requiredRefs = [
    'cloudsContainer',
  ];

  connectedCallback() {
    super.connectedCallback();
    this.toggleSelector = this.getAttribute('toggle-selector') || '.floating-clouds';
    this.boundHandleClick = (event) => this.onToggleClick(event);

    document.addEventListener('click', this.boundHandleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.boundHandleClick) {
      document.removeEventListener('click', this.boundHandleClick);
    }
  }

  onToggleClick(event) {
    const button = event.target.closest(this.toggleSelector);
    if (!button) return;
    if (this.closest('.storm-container')) return;
    this.handleClick(event, button);
  }

  handleClick(event, button) {
    event.preventDefault();
    event.stopPropagation();

    if (button.getAttribute('aria-pressed') === 'true') {
      this.stopFloatingClouds(button);
    } else {
      this.startFloatingClouds(button);
    }
  }

  startFloatingClouds(button) {
    this.stopRainstorm();
    this.refs.cloudsContainer.classList.add('active');
    button?.setAttribute('aria-pressed', 'true');
  }

  stopRainstorm() {
    document.querySelector('rainstorm-component')?.stopStorm();
  }

  stopFloatingClouds(button) {
    this.refs.cloudsContainer.classList.remove('active');
    const toggleButton = button || document.querySelector(this.toggleSelector);
    toggleButton?.setAttribute('aria-pressed', 'false');
  }
}

if (!customElements.get('floating-clouds-component')) {
  customElements.define('floating-clouds-component', FloatingCloudsComponent);
}